import { Component } from '@angular/core';
import { SpotifyComponent } from './components/spotify/spotify.component';
import { CodeComponent } from './components/code/code.component';

@Component({
  selector: 'app-discord',
  templateUrl: './discord.component.html',
  styleUrls: ['./discord.component.less'],
  imports: [SpotifyComponent, CodeComponent],
})
export class DiscordComponent {}
